// @vendors
import { useContext, useState, useEffect } from "react"
import { Form } from 'antd'
import InputMask from 'react-input-mask'
import Context from '../../../context/appContext';
import moment from 'moment';
import { getDate, getDateFormat, getErrorMessage, getValueField, setFormatDate } from "utils/utils";
export default function DateMaskField({ info, key, form, current }) {

    const validate = info.validate ? info.validate : {};
    const { dataForm: { formResponses, hiddenFields, disabledFields } } = useContext(Context);
    const [message, setMessage] = useState({ help: '', status: 'success' });
    const infoHasta = current && current.newItems && current.newItems.find(x =>  x && x.key === 'vigenciaPolizaHasta')
    const [alert, setAlert] = useState(null);
    const momentT = require("moment-timezone");
    const infoAlert = current && current.newItems && current.newItems.find((field) => field && field.key === 'alert-date');

    useEffect(() => {
        getDefaultValue();
    }, []);

    useEffect(() => {
        disabledFields[info.key] && getDefaultValue();
        if (disabledFields[info.key] && (info.key === "fechaDeConstitucionContratante" || info.key === "fechaNacimientoContratante"))
            setMessage({ help: "", status: "success" });
    }, [disabledFields[info.key]]);

    const onBlur = (event) => {
        let value = event.target.value.replace('_', '');
        if (info && info.key === "vigenciaPolizaDesde" || info.key === 'inicioVigenciaSeguro') {
            const valueFormt = moment(value, info.format).format('DD/MM/YYYY 00:00');
            const hourCurrent = moment().format('DD/MM/YYYY HH:mm')
            const plusDay = moment().add(1, 'days').format('DD/MM/YYYY HH:mm');
            const AfterTwelve = moment('12:00', 'HH:mm').format('DD/MM/YYYY HH:mm');
            const valueInsert = moment(valueFormt, 'DD/MM/YYYY 00:00').format(`DD/MM/YYYY ${moment().format('HH:mm')}`);
            const validateDateHour = (moment(AfterTwelve, 'DD/MM/YYYY HH:mm').isBefore(moment(valueInsert, 'DD/MM/YYYY HH:mm')));
            if (valueInsert === hourCurrent) {
                value = validateDateHour ? plusDay : hourCurrent;
                successField(info, value);
                form.setFieldsValue({ [info.key]: moment(value, 'DD/MM/YYYY HH:mm' || 'DD/MM/YYYY').format('DD/MM/YYYY') });
                if (info.key !== 'inicioVigenciaSeguro') {
                    infoHasta && successField(infoHasta, moment(value, 'DD/MM/YYYY HH:mm').add(1, 'year').format('DD/MM/YYYY HH:mm'));
                    form.setFieldsValue({
                        ["vigenciaPolizaHasta"]: moment(value, 'DD/MM/YYYY HH:mm').add(1, 'year').format('DD/MM/YYYY')
                    });
                }
            }
        }
    }

    const validateDate = (event) => {
        let value = event && event.target && event.target.value.replace('_', '') || event;
        if (moment(value, info.format, true).isValid()) {
            if (info && info.key === "vigenciaPolizaDesde") {
                const valueFormt = moment(value, info.format).format('DD/MM/YYYY 00:00');
                const hourCurrent = moment().format('DD/MM/YYYY HH:mm');
                const plusDay = moment().add(1, 'days').format('DD/MM/YYYY HH:mm');
                const AfterTwelve = moment('12:00', 'HH:mm').format('DD/MM/YYYY HH:mm');
                const valueInsert = moment(valueFormt, 'DD/MM/YYYY 00:00').format(`DD/MM/YYYY ${moment().format('HH:mm')}`);
                const validateDateHour = (moment(AfterTwelve, 'DD/MM/YYYY HH:mm').isBefore(moment(valueInsert, 'DD/MM/YYYY HH:mm')));
                const valueFormted = moment(value, info.format).format('DD/MM/YYYY HH:mm');
                const today = moment();
                const validateDateBeforeToday = (moment(today, 'DD/MM/YYYY').isBefore(moment(valueFormted, 'DD/MM/YYYY')));
                const valueWithOutFormate = moment(value, info.format);
                const thiryDay = moment(today).add(30, 'days');
                const validateThirty = (moment(valueWithOutFormate, 'DD/MM/YYYY HH:mm').isBefore(moment(thiryDay, 'DD/MM/YYYY HH:mm')))
                const plusyear = moment(valueFormt, 'DD/MM/YYYY HH:mm').add(1, 'year').format('DD/MM/YYYY HH:mm');
                if (validateDateBeforeToday && validateThirty && !(valueInsert === hourCurrent)) {
                    successField(info, value);
                    form.setFieldsValue({ ["vigenciaPolizaHasta"]: moment(plusyear, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY') });
                    infoHasta && successField(infoHasta, moment(plusyear, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY'));
                } /*else if ((valueInsert === hourCurrent) && validateDateHour) {
                    setMessage({ help: 'A partir de las 12pm las polizas son emitidas con fecha del día siguiente', status: 'error' });
                }*/ else if ((valueInsert === hourCurrent) && !validateDateHour) {
                    successField(info, value);
                    form.setFieldsValue({ ["vigenciaPolizaHasta"]: moment(plusyear, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY') });
                    infoHasta && successField(infoHasta, moment(plusyear, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY'));
                } else {
                    validateDate(info, today);
                    setMessage({ help: getErrorMessage(validate).valid, status: 'error' });
                }
            }
            const ranges = { ...info && info.datePicker };
            if (ranges['minDate'] === 'currentDate') {
                return validateMinCurrentDate(value, ranges)
            }
            if (ranges['minDate'] && ranges['minDate'].startsWith('{')) {
                return validateMinProp(value, ranges)
            }
            ranges['maxDate'] = Number(ranges.maxDate);
            ranges['minDate'] = ranges && (!Number(ranges.minDate) || Number(ranges.minDate) == 0) ? new Date(moment().format("YYYY-MM-DD")).getTime() : Number(ranges.minDate);
            if (value.length === info.format.length && info && info.key !== "vigenciaPolizaDesde" && info.key !== "vigenciaPolizaHasta") {
                value = moment(value, info.format).format('YYYY-MM-DD');
                const inputDate = getDate(value); // se obtienen la edad en años 
                const inputDateInMS = (!Number(info.datePicker.minDate) || Number(info.datePicker.minDate) === 0) ? new Date(moment(value).format('YYYY-MM-DD')).getTime() : inputDate  // se obtiene la edad en milisegundos para lím inferior

                if (inputDate <= ranges.maxDate && inputDateInMS <= ranges.minDate) {
                    successField(info, value);
                } else {
                    setMessage({ help: getErrorMessage(validate).valid, status: 'error' });
                }
            }

        } else {
            setMessage({ help: getErrorMessage(validate).valid, status: 'error' });
        }
    }

    const validateMinCurrentDate = (value, ranges) => {
        const rangesMaxDate = JSON.parse(ranges['maxDate'])
        const now = new Date()
        const date = moment(now);
        const formatDate = getDateFormat(value, 'DD/MM/YYYY')
        const dateValue = moment(formatDate, 'DD/MM/YYYY').set({ hour: 12, minute: 0, second: 0, millisecond: 0 })
        const customMessage = getErrorMessage(validate)
        if (date > dateValue) {
            return setMessage({ help: customMessage.min, status: 'error' });
        }
        date.set({ hour: 23, minute: 59, second: 59, millisecond: 0 })
        const maxDate = date.add(rangesMaxDate.max, rangesMaxDate.type)
        if (dateValue > maxDate) {
            return setMessage({ help: customMessage.max, status: 'error' });
        }

        successField(info, value);
    }

    const validateMinProp = (value, ranges) => {
        try {
            const rangesMinDate = JSON.parse(ranges['minDate'])
            const rangesMaxDate = JSON.parse(ranges['maxDate'])
            const initDate = formResponses.find(x => x.key === rangesMinDate.prop)
            const customMessage = getErrorMessage(validate)
            if (!initDate || !initDate.value) {
                return setMessage({ help: customMessage.min, status: 'error' });
            }
            const minDate = moment(initDate.value, 'DD/MM/YYYY HH:mm').add(rangesMinDate.min, rangesMinDate.type)
            const formatDate = getDateFormat(value, 'DD/MM/YYYY')
            const dateValue = moment(formatDate, 'DD/MM/YYYY').set({ hour: 12, minute: 0, second: 0, millisecond: 0 })

            if (dateValue < minDate) {
                return setMessage({ help: customMessage.min, status: 'error' });
            }
            const initDateValue = getDateFormat(initDate.value, 'DD/MM/YYYY')
            const maxDate = moment(`${initDateValue} 23:59`, 'DD/MM/YYYY HH:mm').add(rangesMaxDate.max, rangesMaxDate.type)
            if (dateValue > maxDate) {
                return setMessage({ help: customMessage.max, status: 'error' });
            }

            return successField(info, value);
        } catch (error) {
            setMessage({ help: getErrorMessage(validate).valid, status: 'error' });
        }

    }

    const getAlert = (info) => {
        let alert = null
        const date = moment();
        const dateValue = moment().set({ hour: 12, minute: 0, second: 0, millisecond: 0 })
        if (info && (date > dateValue)) {
            alert = <div className='alert-info'>
                <p dangerouslySetInnerHTML={{ __html: info.content }}></p>
            </div>
        } else { return null }
        return alert
    }

    const successField = (infoS, value, valid = true) => {
        infoS.value = value;
        const index = formResponses.findIndex(x => x.key === infoS.key);
        index != -1 ? formResponses[index].value = value : formResponses.push(infoS);
        if (valid) {
            setMessage({ help: '', status: 'success' });
        }
    }

    const getDefaultValue = () => {
        const chkData = formResponses.find((item) => item.key === "datosContratanteIgualAsegurado");
        const hasCheckLoadLastStepInfo = current.newItems.find(x => x && x.key === "datosContratanteIgualAsegurado");
        const indexField = formResponses.findIndex(x => x.key === info.key);
        let value = "";
        if (info.customDefaultValue && (!hasCheckLoadLastStepInfo || (hasCheckLoadLastStepInfo && chkData && chkData.value))) {
            const item = formResponses.find((x) => x.key === info.customDefaultValue);
            value = moment(item && item.value ? item.value : '').format('DD/MM/YYYY');
            disabledFields[info.key] = value && true;
        } else if (info && info.value && info.value !== null && info.value !== '') {
            value = getDateFormat(info.value, 'DD/MM/YYYY')
        } else if (!info.value && form.getFieldValue(info.key)) {
            value = getDateFormat(form.getFieldValue(info.key), 'DD/MM/YYYY')
        }
        if (value && value !== '') {
            if (indexField !== -1 && (info.key === 'vigenciaPolizaHasta' || info.key === 'vigenciaPolizaDesde' || info.key === 'inicioVigenciaSeguro')) {
                value = formResponses[indexField].value;
            }
            form.setFieldsValue({ [info.key]: value && moment(value, 'DD/MM/YYYY HH:mm' || 'DD/MM/YYYY').format('DD/MM/YYYY') });
            value && validateDate({ target: { value: value } });
        }
        if (info && info.key === "vigenciaPolizaDesde" || (info.key === 'inicioVigenciaSeguro' && !value)) {
            const hourCurrent = moment().format('DD/MM/YYYY HH:mm')
            const plusDay = moment().add(1, 'days').format('DD/MM/YYYY HH:mm')
            const AfterTwelve = moment('12:00', 'HH:mm').format('DD/MM/YYYY HH:mm');
            const validateDateHour = moment(hourCurrent, 'DD/MM/YYYY HH:mm').isBefore(moment(AfterTwelve, 'DD/MM/YYYY HH:mm'));
            const dateFinal = validateDateHour ? hourCurrent : plusDay
            form.setFieldsValue({ [info.key]: moment(dateFinal, 'DD/MM/YYYY HH:mm').format('DD/MM/YYYY') });
            successField(info, dateFinal, false);
            if (info.key !== 'inicioVigenciaSeguro') {
                form.setFieldsValue({ ["vigenciaPolizaHasta"]: moment(dateFinal, 'DD/MM/YYYY HH:mm').add(1, 'year').format('DD/MM/YYYY') });
                successField(infoHasta, moment(dateFinal, 'DD/MM/YYYY HH:mm').add(1, 'year').format('DD/MM/YYYY HH:mm'));
                let currentDate = momentT()
                    .tz("America/Mexico_City")
                    .format("YYYY-MM-DD");
                const hour = momentT().tz("America/Mexico_City").format("HH");
                /*if (hour >= 12) {
                    currentDate = moment(currentDate).add(1, "days").format("DD/MM/YYYY");
                    form.setFieldsValue({ [info.key]: currentDate });
                    const renderAlert = getAlert(infoAlert);
                    renderAlert && setAlert(renderAlert);
                }*/
                // (valueInsert === hourCurrent) && !validateDateHour && setMessage({ help: 'A partir de las 12pm las polizas son emitidas con fecha del día siguiente', status: 'error' });
            }
        }
        //  else
        //     if (info && (info.key === 'fechaNacimientoContratante' || info.key === 'fechaNacimientoAsegurado' || info.key === 'fechaDeConstitucionAsegurado' || info.key === 'fechaDeConstitucionContratante')) {
        //         value = getValueField(info.key, formResponses);
        //         value && value !== 'Fecha inválida' && form.setFieldsValue({ [info.key]: setFormatDate(value) });
        //     }
    }


    return (
        info && info.key !== 'vigenciaPolizaDesde' ? <Form.Item
            className='align-start'
            label={info.label}
            name={info.key}
            key={key}
            hidden={hiddenFields[info.key]}
            tooltip={info.tooltip || ''}
            rules={[
                {
                    required: hiddenFields[info.key] || disabledFields[info.key] || info.disabled ? false : validate.required,
                    message: getErrorMessage(validate).required
                },
                {
                    pattern: new RegExp(message.status === 'error' ? info.key !== 'vigenciaPolizaHasta' ? 'error' : '' : ''),
                    message: message.help
                }
            ]}
        >
            <InputMask
                className='ant-input'
                mask={info.format.replace(/[dDMYyhHmS]/g, '9')}
                placeholder={info.format}
                disabled={info && info.key === 'vigenciaPolizaHasta' ? true : disabledFields[info.key]}
                onChange={validateDate}
                onBlur={onBlur}
            >

            </InputMask>
        </Form.Item> :
            <>
                <Form.Item form={form}>

                    <Form.Item
                        label={info.label}
                        name={info.key}
                        key={key}
                        hidden={hiddenFields[info.key]}
                        tooltip={info.tooltip || ''}
                        rules={[
                            {
                                required: hiddenFields[info.key] || disabledFields[info.key] || info.disabled ? false : validate.required,
                                message: getErrorMessage(validate).required
                            },
                            {
                                pattern: new RegExp(message.status === 'error' ? info.key !== 'vigenciaPolizaHasta' ? 'error' : '' : ''),
                                message: message.help
                            }
                        ]}
                    >

                        <InputMask
                            className='ant-input'
                            mask={info.format.replace(/[dDMYyhHmS]/g, '9')}
                            placeholder={info.format}
                            disabled={disabledFields[info.key]}
                            onChange={validateDate}
                            onBlur={onBlur}
                        >

                        </InputMask>
                    </Form.Item>
                    {info && info.key === 'vigenciaPolizaDesde' && alert &&
                        <div className="datepicker-age">{alert}</div>
                    }
                </Form.Item>
            </>

    )
}